export default "__VITE_ASSET__8292632b__"